/**
 * Model for Sanction Match response.
 *
 * @author jagpreet.singh@vernuso.com (Jagpreet Singh)
 */
export class SanctionMatchResponse {
    suggestionList: Array<SanctionMatchRecord>;
    date: string;
}

export class SanctionMatchRecord {
    sanctionEntity: SanctionEntity;
    relationEntityId: number;
    matchResolution: number;
    falseMatchReason: number;
    comments: string;
}

export class SanctionEntity {
    id: string;
    firstName: string;
    middleName: string;
    lastName: string;
    globalName: string;
    listName: string;
    birthDate: string;
    birthCountry: string;
    nationality: string;
    jsonData: string;
    source: string;
    /** Match tokens from Beamar (matchedNames), when available. */
    matchedTokens?: string;
}

export enum SanctionMatchResolution {
    PROBABLE = <any>'PROBABLE',
    TRUE = <any>'TRUE',
    FALSE = <any>'FALSE',
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/sanction-matches.model.ts